<template>
  <Select
    :items="arrayCompoeFaturamento"
    :selectedItem="filter.compoeFaturamento"
    :label="filtro.name"
    :searchPlaceholder="$i18n('interface.novo_filtro.compoe_faturamento')"
    @atualizar="atualizar"
    :filtro_id="filtro.filtro"
    :filtro_default="filtro.default"
    :path="path"
  />
</template>
<script>
import Select from '../../components/Select.vue';
export default {
  components: {
    Select,
  },
  props: {
    filtro: {
      type: Object,
      required: true,
    },
    path: {
      type: String,
      required: true
    },
    initialState: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      filter: {
        compoeFaturamento: {
          id: '',
          name: '',
        },
      },
      arrayCompoeFaturamento: [
        { id: 'true', name: 'Sim' },
        { id: 'false', name: 'Não' },
      ],
    };
  },
  methods: {
    atualizar(compoeFaturamento) {
      this.filter.compoeFaturamento = compoeFaturamento;

      this.$aplicaFiltroEmURL(this.filtro.filtro, this.filter.compoeFaturamento.id, this.path);
      this.$store.commit('addFiltro', this.filtro);
      this.$store.commit('addFiltroAplicado', {
        filtro: this.filtro.filtro,
        valor: this.filter.compoeFaturamento.id
      });
    },
  },
  mounted() {
    const filtroAplicado = this.$store.state.filtroAplicados[this.filtro.filtro];
    this.$renderFiltroSelect(filtroAplicado, this.arrayCompoeFaturamento, this.filter.compoeFaturamento);
  },
}
</script>
